import axios from 'axios';

export default {
  getAll() {
    return axios.get('/ticket-print-blocks');
  },

  create(data) {
    return axios.post('/ticket-print-blocks', data);
  },

  update(id, data) {
    return axios.put(`/ticket-print-blocks/${id}`, data);
  },

  delete(id) {
    return axios.delete(`/ticket-print-blocks/${id}`);
  },

  uploadImage(file) {
    const form = new FormData();
    form.append('image', file);
    return axios.post('/ticket-print-blocks/image', form, { headers: { 'Content-Type': 'multipart/form-data' } });
  }
}
